import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = "";
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [business, setBusiness] = useParameter<number>("@business-units");
  const [calendar] = useParameter<number[]>("@calendar");
  const [e_countries] = useParameter<number[]>("@e_countries");
  const [e_commodities] = useParameter<number[]>("@e_commodities");
  const [e_calendar] = useParameter<number[]>("@e_calendar");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@business-units": business,
      "@calendar": calendar,
      "@e_countries": e_countries,
      "@e_commodities": e_commodities,
      "@e_calendar": e_calendar,
    });
  }, [title, subtitle, business, e_commodities, calendar, e_calendar, e_countries, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setBusiness((parameters["@business-units"].value as string[]).map(Number)[0]);
    },
    [setBusiness]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
